import * as apiClient from '../api/apiClient';
import { buildPagedQuery } from '../api/pagedQuery';
import { unwrapPagedResponseModel, unwrapResponseModel } from '../api/responseModel';

const INDEX_PATH = '/api/anioAcademico/Index';

async function requestAndUnwrap(requestPromise) {
  const { data } = await requestPromise;
  return unwrapResponseModel(data);
}

export function resetAnioAcademicoListCacheForTests() {
  // Sin caché deduplicada tras F4-011.
}

export function listAniosAcademicos(query = { page: 1, pageSize: 10 }) {
  const qs = buildPagedQuery(query);
  return apiClient.get(`${INDEX_PATH}?${qs}`).then(({ data }) => unwrapPagedResponseModel(data));
}

export function lookupAniosAcademicos(query = { page: 1, pageSize: 5 }) {
  return listAniosAcademicos(query);
}

export function getAnioAcademico(id) {
  return requestAndUnwrap(apiClient.get(`/api/anioAcademico/${id}`));
}

export function deleteAnioAcademico(id) {
  return requestAndUnwrap(apiClient.get(`/api/anioAcademico/delete/${id}`));
}

export function saveAnioAcademico(payload) {
  return requestAndUnwrap(apiClient.post('/api/anioAcademico', payload));
}

export function updateAnioAcademico(payload) {
  return requestAndUnwrap(apiClient.post('/api/anioAcademico', payload));
}
